import { render, staticRenderFns } from "./VoucherDetail.vue?vue&type=template&id=13cb813a&scoped=true"
import script from "./VoucherDetail.vue?vue&type=script&lang=js"
export * from "./VoucherDetail.vue?vue&type=script&lang=js"
import style0 from "./VoucherDetail.vue?vue&type=style&index=0&id=13cb813a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cb813a",
  null
  
)

export default component.exports